import React from 'react';

import styled from 'styled-components';

import { FREQUENCY_OPTIONS } from 'components/CommunityInfo/careTypes/constants';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import CMASummaryTableDataValuesDifference from './CMASummaryTableDataValuesDifference';
import { getFeeInfoTestId } from './testIdUtils';
import { CMASummaryFilters } from './types';
import { parseCMASummaryFeeData } from './utils';

const Title = styled.div`
  font-family: var(--font-regular);
  font-size: 14px;
`;

const Subtitle = styled.div`
  color: var(--text-secondary);
  font-size: 12px;
  max-width: 220px;
  white-space: normal;
  overflow-wrap: break-word;
`;

type Props = { fee: [number | number[], number]; dataTestId?: string };

const CMASummaryTableDataLivingTypeFee = ({ fee, dataTestId }: Props) => {
  const { viewFilters } = useCommunityViewContext();
  if (!fee?.length) {
    return null;
  }
  const filters = viewFilters as CMASummaryFilters;
  const [value, communityFeeEquivalentFactor] = fee;
  const [feeValue, feeDifference] = parseCMASummaryFeeData(value, filters?.viewOptions?.valueDisplay);

  const predefinedEquivalentLabel = FREQUENCY_OPTIONS.find((item) => item.value == communityFeeEquivalentFactor)?.label;

  const communityFeeEquivalentLabel =
    predefinedEquivalentLabel ??
    (communityFeeEquivalentFactor ? `Equal to ${communityFeeEquivalentFactor * 100}% of month's rent` : undefined);

  return (
    <div data-test-id={dataTestId}>
      {typeof feeValue === 'number' && (
        <Title>
          ${feeValue.toLocaleString(undefined, { maximumFractionDigits: 2 })}{' '}
          <CMASummaryTableDataValuesDifference difference={feeDifference} />
        </Title>
      )}
      {typeof feeValue !== 'number' && '-'}
      {communityFeeEquivalentFactor && communityFeeEquivalentLabel && (
        <Subtitle>{communityFeeEquivalentLabel}</Subtitle>
      )}
    </div>
  );
};

export default CMASummaryTableDataLivingTypeFee;
